import type { Department, Course } from "./user";
import type { Period } from "./period";
import { Instructor } from "./instructor";

export type TrainingType = {
  id: number;
  department: Department;
  course: Course[];
  sport_event: string;
  sport_sub_events: string[];
  instructor_detail: Instructor;
  instructor: number;
  schedule: Array<Period>;
  student_limit: number;
  attendance_book: string | null;
  attendance_book_url: string;
  gallery: string[];
  gallery_urls: { filename: string; url: string }[];
};

export const sportTypes = {
  record: ["육상", "수영", "루지", "봅슬레이", "빙상", "역도"],
  net: [
    "라켓볼",
    "배드민턴",
    "스쿼시",
    "소프트테니스",
    "탁구",
    "테니스",
    "배구",
    "세팍타크로",
    "족구",
  ],
  martial: [
    "국학기공",
    "검도",
    "가라테",
    "우슈",
    "유도",
    "주짓수",
    "택견",
    "태권도",
    "합기도",
    "레슬링",
    "복싱",
    "킥복싱",
    "씨름",
    "펜싱",
  ],
  aesthetic: [
    "댄스스포츠",
    "줄넘기",
    "체조",
    "힙합",
    "레크리에이션",
    "보디빌딩",
    "에어로빅",
    "치어리딩",
  ],
  area: [
    "축구",
    "풋살",
    "농구",
    "럭비",
    "핸드볼",
    "아이스하키",
    "하키",
    "플로어볼",
    "야구",
    "소프트볼",
  ],
  target: ["궁도", "당구", "볼링", "양궁", "사격", "컬링"],
  // mix: ["근대5종", "바이애슬론", "트라이애슬론"],
  ecology: [
    "인라인스케이트",
    "자전거",
    "사이클",
    "골프",
    "파크골프",
    "게이트볼",
    "승마",
    "산악",
    "등산",
    "수상스키",
    "요트",
    "조정",
    "카누",
    "스키",
    "수중",
    "스킨스쿠버",
    "오리엔티어링",
    "윈드서핑",
    "패러글라이딩",
    "행글라이딩",
  ],
};

export const categoryTranslator: Record<string, string> = {
  record: "기록형",
  net: "네트형",
  martial: "무도형",
  aesthetic: "심미형",
  area: "영역/필드형",
  target: "타깃형",
  mix: "복합형",
  ecology: "생태형",
  racket: "라켓형",
  group: "단체형",
  training: "수련형",
  combat: "격투형",
  sport: "스포츠형",
  expression: "표현형",
  ball: "구기형",
  equipment: "도구형",
  life: "생활환경형",
  nature: "자연환경형",
};
